import { z } from 'zod';
import { visualizationBlockSpecSchema } from './block.ts';

export const layoutBreakpointSchema = z.object({
  name: z.string().min(1),
  minWidth: z.number().nonnegative().finite(),
  maxWidth: z.number().positive().finite().optional(),
  columns: z.number().int().positive().default(1),
  gap: z.number().nonnegative().finite().default(16),
  mode: z.enum(['freeform', 'grid', 'stack']).default('grid'),
  columnRatios: z.array(z.number().positive().max(1)).max(100).optional(),
}).strict().superRefine((breakpoint, context) => {
  if (
    breakpoint.maxWidth !== undefined
    && breakpoint.maxWidth < breakpoint.minWidth
  ) {
    context.addIssue({
      code: z.ZodIssueCode.custom,
      path: ['maxWidth'],
      message: 'maxWidth 不能小于 minWidth',
    });
  }
});

export const layoutSpecSchema = z.object({
  mode: z.enum(['freeform', 'grid', 'stack']).default('freeform'),
  columns: z.number().int().positive().max(1000).optional(),
  /** 内容块之间的视觉间距，单位为 px；不随容器宽度线性放大。 */
  gap: z.number().nonnegative().finite().max(10000).optional(),
  /** grid 模式下各轨道宽度比例，例如 [0.22, 0.78]。 */
  columnRatios: z.array(z.number().positive().max(1)).max(100).optional(),
  /** render-time 响应式断点；渲染层按容器宽度实时选择。 */
  breakpoints: z.array(layoutBreakpointSchema).max(20).optional(),
}).strict();

export const visualizationPageSpecSchema = z.object({
  id: z.string().min(1).max(200),
  title: z.string().max(100000).default(''),
  layout: layoutSpecSchema.default({ mode: 'freeform' }),
  blocks: z.array(visualizationBlockSpecSchema).max(1000).default([]),
}).strict();

export type LayoutSpec = z.infer<typeof layoutSpecSchema>;
export type LayoutBreakpoint = z.infer<typeof layoutBreakpointSchema>;
export type VisualizationPageSpec = z.infer<
  typeof visualizationPageSpecSchema
>;
